module.exports = __webpack_public_path__ + "img/Risk_Rate_v2_24.f3f7974c.png";